﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    loadTravelCertPageDataAction,
    mailTravelCertAction
} from './State/actions';

import {getEpiData} from '../../Utils/epiHelpers';

import Loader from '../../UI/Loader';
import ErrorMessage from '../../UI/ErrorMessage';
import RawHtml from '../../UI/RawHtml';

import {
    LinkButton,
    ActionButton
} from '../../UI/pageComponents';

import definitions from '../../Style/LfStyleDefinitions';
import {mediaQuery, clearFix} from '../../Style/cssHelpers';

class TravelCertificatePage extends React.Component {
    static get propTypes() {
        return {
            mountRootId: PropTypes.string.isRequired
        }
    }

    constructor(props) {
        super(props);
        this.heading = getEpiData('heading', this.props.mountRootId);
        this.preamble = getEpiData('preamble', this.props.mountRootId);
    }

    componentDidMount() {
        this.props.loadData();
    }

    render() {
        return (
            <Wrapper>
                <Heading>{this.heading}</Heading>
                {!this.props.hasErrored &&
                    <Preamble>
                        <RawHtml>{this.preamble}</RawHtml>
                    </Preamble>
                }

                {this.props.hasErrored &&
                    <ErrorMessage message={`Ooops! Ett fel har uppstått: ${typeof this.props.error === 'string' ? this.props.error : this.props.error.message }`} />
                }

                {this.props.isLoading &&
                    <Loader color={definitions.colors.blueBackground}/>
                }

                {!this.props.isLoading && !this.props.hasErrored &&
                    <SectionWrapper>
                        <ButtonWrapper>
                            <LinkButton
                                href={this.props.data.travelCertificateUrl}
                                target="_blank"
                                download
                            >
                                Ladda ner reseskydd
                            </LinkButton>
                        </ButtonWrapper>

                        <ButtonWrapper>
                            {!this.props.data.travelCertMailSent &&
                                <ActionButton
                                    onClick={this.props.mailTravelCert}
                                >
                                   Maila reseskydd till {this.props.data.customerInfo.emailAddress}
                                </ActionButton>
                            }

                            {this.props.data.travelCertMailSent &&
                                <strong>Ditt reseskydd har skickats till {this.props.data.customerInfo.emailAddress}. Trevlig resa!</strong>
                            }
                        </ButtonWrapper>
                    </SectionWrapper>
                }
            </Wrapper>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.travelCertPageData,
        hasErrored: state.pageHasErrored,
        error: state.pageError,
        isLoading: state.pageIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadData: () => dispatch(loadTravelCertPageDataAction()),
        mailTravelCert: () => dispatch(mailTravelCertAction())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TravelCertificatePage);

// styles

export const Wrapper = styled.div`
    position: relative;
    margin: 0 0 100px 0;
    padding: 0;

    ${mediaQuery.custom(`
        padding: 13px;
    `, '1234px')}

    ${mediaQuery.large(`
        padding: 21px;
    `)}
`;

export const Heading = styled.h1`
    padding-bottom: 30px;
    margin-top: 50px;
    margin-bottom: 35px;

    font-family: ${definitions.fonts.heading};
    font-size: 60px;
    color: ${definitions.colors.almostBlack};

    border-bottom: 1px solid ${definitions.colors.grayBorder};

    ${mediaQuery.small(`
        font-size: 28px;
    `)}

    ${mediaQuery.large(`
        margin-bottom: 10px;
        margin-top: 10px;
        padding: 0;

        border: none;
    `)}
`;

export const Preamble = styled.div`
    max-width: 60%;
    margin-bottom: 20px;

    font-family: ${definitions.fonts.main};
    font-size: 20px;
    color: ${definitions.colors.almostBlack};

    ${mediaQuery.large(`
        max-width: none;
        font-size: 16px;
        line-height: 1.5;
    `)}
`;

export const SectionWrapper = styled.div`
    position: relative;
    max-width: 800px;
    width: 100%;
`;

export const ButtonWrapper = styled.div`
    margin-top: 15px;

    ${mediaQuery.small(`
        display: block;
        width: 100%;
        text-align: center;

        margin-top: 20px;
    `)}
`;
